import { render, staticRenderFns } from "./DelayedLoader.vue?vue&type=template&id=2edac9f8&"
import script from "./DelayedLoader.vue?vue&type=script&lang=js&"
export * from "./DelayedLoader.vue?vue&type=script&lang=js&"
import style0 from "./DelayedLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports